module.exports = __webpack_public_path__ + "static/media/permissrion-location-v1.93176ff5.png";